(function () {
  var TARGET_CLASS = "wl-mui-fadein";
  var ACTIVE_CLASS = "wl-mui-fadein--active";
  var READY_CLASS = "wl-mui-fadein--ready";

  // Tuning knobs
  var EASE = "cubic-bezier(0.25, 0.1, 0.25, 1)";
  var IN_OPACITY_MS = 750;
  var IN_TRANSFORM_MS = 810;
  var OUT_OPACITY_MS = 500;
  var OUT_TRANSFORM_MS = 500;

  function supportsReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function setInitialStyle(el) {
    el.style.opacity = "0";
    el.style.transform = "translate3d(0px, 2rem, 0px) scale(1.02)";
    el.style.willChange = "opacity, transform";
    el.style.transition =
      "opacity " + OUT_OPACITY_MS + "ms " + EASE + ", transform " + OUT_TRANSFORM_MS + "ms " + EASE;
  }

  function setActiveStyle(el) {
    el.style.opacity = "1";
    el.style.transform = "translate3d(0px, 0px, 0px) scale(1)";
    el.style.transition =
      "opacity " + IN_OPACITY_MS + "ms " + EASE + ", transform " + IN_TRANSFORM_MS + "ms " + EASE;
  }

  function prepElement(el) {
    if (el.classList.contains(READY_CLASS)) return false;
    el.classList.add(READY_CLASS);
    if (supportsReducedMotion()) {
      el.style.opacity = "1";
      el.style.transform = "none";
      return false;
    }
    setInitialStyle(el);
    return true;
  }

  function shouldRemove(el) {
    if (!el.hasAttribute("data-remove")) return true;
    return String(el.getAttribute("data-remove")).toLowerCase() !== "false";
  }

  function FadeinController() {
    // Same meaning as before: fractions of the viewport height.
    // The "active area" runs from borderTop to borderBottom.
    this.borderTop = 0;
    this.borderBottom = 0.8;
    this.remove = true;
    this.observer = null;
    this.onIntersectBound = this.onIntersect.bind(this);
  }

  // Converts borderTop/borderBottom into an IntersectionObserver rootMargin.
  // borderBottom 0.8 -> bottom margin -20%; borderTop 0 -> top margin 0%.
  FadeinController.prototype.getRootMargin = function () {
    var top = -this.borderTop * 100;
    var bottom = -(1 - this.borderBottom) * 100;
    return top + "% 0px " + bottom + "% 0px";
  };

  FadeinController.prototype.init = function () {
    this.observer = new IntersectionObserver(this.onIntersectBound, {
      root: null,
      rootMargin: this.getRootMargin(),
      threshold: 0,
    });
    this.scan();
  };

  FadeinController.prototype.scan = function () {
    var list = Array.prototype.slice.call(document.getElementsByClassName(TARGET_CLASS));
    for (var i = 0; i < list.length; i++) {
      if (prepElement(list[i])) this.observer.observe(list[i]);
    }
  };

  FadeinController.prototype.onIntersect = function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var el = entries[i].target;
      var isActive = el.classList.contains(ACTIVE_CLASS);

      if (entries[i].isIntersecting) {
        if (!isActive) {
          el.classList.add(ACTIVE_CLASS);
          setActiveStyle(el);
        }
      } 
      // else if (isActive && this.remove && shouldRemove(el)) {
      //   el.classList.remove(ACTIVE_CLASS);
      //   setInitialStyle(el);
      // }
    }
  };

  function start() {
    if (!("IntersectionObserver" in window)) {
      var all = document.getElementsByClassName(TARGET_CLASS);
      for (var i = 0; i < all.length; i++) {
        all[i].style.opacity = "1";
        all[i].style.transform = "none";
      }
      return;
    }

    var controller = new FadeinController();
    controller.init();

    // Pick up elements added later
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        controller.scan();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();